<template>
    <!-- footer page  -->
    <div class="footer">
        <div class="mt-5">
            <div class="d-flex justify-content-center">
                <p class="footer-Para"> Copyright © 2024 Chloe Almazien All Rights Reserved</p>

                <p id="demi"></p>
            </div>

        </div>

        
    </div>
</template>
<script>
// const c = new Date();
// document.getElementById("demi").innerHTML = c.getFullYear();
export default {
    name: 'FooterComp',
}
</script>
<style scoped>
    
</style>